import { gql } from "@apollo/client";

export const ALL_SURVEY_CATEGORIES = gql`
  query {
    allCategoriesSurvey {
      withError
      message
      outputData {
        idCategorySurvey
        categoryDescription
        recordState
        createUser
        createDate
        lastUpdateUser
        lastUpdateDate
        isGlobal
      }
    }
  }
`;

export const ALL_QUESTION_CATEGORIES = gql`
  query {
    allCategoriesQuestion {
      withError
      message
      outputData {
        idCategoryQuestion
        description
        recordState
        createUser
        lastUpdateUser
        createDate
      }
    }
  }
`;

export const ALL_ANSWER_CATEGORY = gql`
  query {
    allCategoriesAnswer {
      idCategoryAnswer
      description
      active
      additionalDataType
      additionalDataParameters
    }
  }
`;

export const ALL_QUESTION_SURVEY = gql`
  query ($idSurvey: Int!) {
    allQuestionsSurvey(where: { idSurvey: { eq: $idSurvey } }) {
      idQuestionSurvey
      idQuestion
      idSurvey
      jsonConfiguration
      active
      createUser
      createdDate
      lastUpdateUser
      lastUpdatedDate
    }
  }
`;

export const SURVEYS_I_CAN_APPROVE = gql`
  query (
    $surveyStateIds: [Int!]
    $searchBy: String
    $first: Int
    $last: Int
    $after: String
    $before: String
  ) {
    surveysICanApprove(
      first: $first
      last: $last
      after: $after
      before: $before
      searchBy: $searchBy
      surveyStateIds: $surveyStateIds
      order: { idSurvey: DESC }
    ) {
      nodes {
        idSurvey
        surveyName
        surveyDescription
        idSurveyState
        activateSurveyDate
        createUser
        countryId
      }
      totalCount
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;

export const ALL_SURVEYS_DETAIL_REPORTS = gql`
  query (
    $first: Int
    $last: Int
    $after: String
    $before: String
    $searchBy: String
  ) {
    allSurveyReport(
      first: $first
      last: $last
      after: $after
      before: $before
      searchBy: $searchBy
      surveyStateIds: [2, 3]
      order: { idSurvey: DESC }
    ) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      totalCount
      nodes {
        idSurvey
        surveyName
        surveyDescription
        createUser
        idSurveyState
        countryId
        activateSurveyUser
        activateSurveyDate
        answeredSurveys
        assignedUsers
        remainingSurveys
        surveyLocationInfo {
          countryName
          cityName
        }
      }
    }
  }
`;

export const DOWNLOAD_PENDING_USERS_ANSWER = gql`
  query ($idSurvey: Int!, $surveyName: String) {
    downloadPendingUsersAnswersBySurvey(
      input: { surveyId: $idSurvey, surveyName: $surveyName }
    ) {
      message
      withError
      outputData {
        Survey_name: surveyName
        CCMS_UserName: ccmsUser
        Name: userFirstName
        Last_Name: userLastName
        Client_Name: clientName
        Country: countryName
        Site_Location: cityName
      }
    }
  }
`;

export const SURVEY_BY_ID = gql`
  query ($idSurvey: Int!) {
    surveyById(surveyId: $idSurvey) {
      idSurvey
      surveyName
      surveyDescription
      idSurveyState
      idCategorySurvey
      idFormatSurvey
      questionsPerPage
      integrationTpclient
      isAnonymous
      isGlobal
      isTemplate
      setRandomQuestions
      tpsurveyGlobalClients {
        clientTpCode
      }
      tpsurveyConfigurationSurveys {
        idConfigurationSurvey
        idSurvey
        field
        jsonConfiguration
      }
      tpsurveyQuestionSurveys {
        idQuestionSurvey
        idQuestion
        idSurvey
        jsonConfiguration
        isMandatory
        order
        active
        isDependent
        idParentQuestion
        dependentAnswer
        idQuestionNavigation {
          idQuestion
          nameQuestion
          validationText
          idCategoryQuestion
          active
        }
      }
    }
  }
`;

export const ROLE_BY_LEVEL = gql`
  query {
    rolesByUserProfile {
      id: roleId
      name: friendlyDescription
    }
  }
`;

export const ALL_AUTHENTICATION_METHODS = gql`
  query {
    authenticationMethodList {
      id: authMethodId
      name: authMethodName
    }
  }
`;

export const ALL_STATES_BY_COUNTRY = gql`
  query ($clientId: Int!, $countryId: Int!) {
    statesByCountry(clientId: $clientId, countryId: $countryId) {
      id: stateId
      name: stateName
    }
  }
`;

export const ALL_CITIES_BY_STATE = gql`
  query ($clientId: Int!, $state: Int!) {
    citiesByState(clientId: $clientId, stateId: $state) {
      id: cityId
      name: cityName
    }
  }
`;

export const ALL_LOBS = gql`
  query ($tenantId: String) {
    lobsByTenant(tenantId: $tenantId, where: { statusId: { eq: 1 } }) {
      name
      id: lobid
      statusId
    }
  }
`;

export const ALL_LOBS_COUNTRY = gql`
  query ($countryId: Int!) {
    lobsListByCountry(countryId: $countryId, where: { enabled: { eq: true } }) {
      lobId
      lobName
      lobDescription
      enabled
      createDate
      createName
      country {
        countryId
        countryName
      }
    }
  }
`;

export const ALL_SITES_BY_CITY = gql`
  query ($clientId: Int!, $cityId: Int!) {
    sitesByCity(cityId: $cityId, clientId: $clientId) {
      id: siteId
      name: siteName
      statusId
    }
  }
`;

export const CLIENTSITE_BY_CLIENTID_SITEID = gql`
  query ($clientId: Int!, $siteId: Int!) {
    clientsSites(
      where: { clientId: { eq: $clientId }, and: { siteId: { eq: $siteId } } }
    ) {
      clientSiteId
    }
  }
`;

export const USERS_IN_ROLE2 = gql`
  query ($rolesId: [Int!], $offset: Int, $limit: Int, $clientId: Int, $search: String) {
    userListAdvancedSearch(
      roleIds: $rolesId
      offset: $offset
      limit: $limit
      clientId: $clientId
      search: $search
    ) {
      userId
      userFirstName
      userLastName
      userFullName
      userTpId
      userCcms
    }
  }
`;

export const COACHES_CANDIDATES = gql`
  query ($rolesId: [Int!]) {
    coachesCandidates(rolesId: $rolesId) {
      userId
      userFullName
      userEmailAddress
    }
  }
`;

export const ALL_ASSIGNED_RECURRENCES_SURVEYS = gql`
  query (
    $searchBy: String
    $first: Int
    $last: Int
    $after: String
    $before: String
  ) {
    allAsignedRecurrencesSurveys(
      searchBy: $searchBy
      first: $first
      last: $last
      after: $after
      before: $before
      order: { idSurvey: DESC }
    ) {
      nodes {
        idSurvey
        surveyName
        surveyDescription
        activateSurveyDate
        createUser
        goToSurveyInfo {
          goToSurvey
          schedule {
            idSurveyScheduling
            startDate
            endDate
          }
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      totalCount
    }
  }
`;

export const ROLE_BY_USER = gql`
  query ($userId: Int!) {
    rolesByUserId(userId: $userId) {
      roleId
      roleDescription
    }
  }
`;

export const USERNAME_BY_USER = gql`
  query ($userId: Int!) {
    allUsers(where: { userId: { eq: $userId } }) {
      ccmsuser
    }
  }
`;

export const COUNTRIES_BY_CLIENT = gql`
  query {
    countryLocationList {
      countryId
      countryName
      cities {
        cityId
        cityName
      }
    }
  }
`;

export const COUNTRIES_BY_CLIENT_FOR_CREATE_USERS = gql`
  query {
    countryLocationList {
      id: countryId
      name: countryName
      cities {
        cityId
        cityName
      }
    }
  }
`;

export const STATES_BY_CLIENT = gql`
  query ($clientId: Int!, $countryId: [Int!]) {
    statesByCountrys(clientId: $clientId, countryId: $countryId) {
      id: stateId
      name: stateName
    }
  }
`;

export const CITIES_BY_CLIENT = gql`
  query ($clientId: Int!, $stateId: [Int!]) {
    citiesByStates(clientId: $clientId, stateId: $stateId) {
      id: cityId
      name: cityName
    }
  }
`;

export const SITES_BY_CLIENT = gql`
  query ($clientId: Int!, $cityId: [Int!]) {
    sitesByCities(clientId: $clientId, cityId: $cityId) {
      siteId
      siteName
      createUser
      createDate
      city {
        cityId
        cityName
        sites {
          siteId
          siteName
        }
        state {
          stateId
          stateName
          country {
            countryId
            countryName
          }
        }
      }
    }
  }
`;

export const ALL_ROLES_BY_LEVEL = gql`
  query {
    rolesByUserProfile {
      roleId
      roleDescription
      roleLevel
      roleName
      friendlyDescription
    }
  }
`;

export const ALL_ROLES_BY_USER_PROFILE = gql`
  query {
    rolesByUserProfile {
      roleId
      roleDescription
      roleLevel
      roleName
      friendlyDescription
    }
  }
`;

export const LOBS_BY_CLIENT = gql`
  query ($clientId: Int!) {
    lobsByClient(clientId: $clientId, where: { statusId: { eq: 1 } }) {
      lobid
      name
      description
      createDate
      createUser
      statusId
    }
  }
`;

export const USERS_ADVANCE_SEARCH = gql`
  query (
    $countries: [Int!]
    $cities: [Int!]
    $roles: [Int!]
    $lobs: [Int!]
    $isCoMoUser: Boolean
  ) {
    userListAdvancedSearch(
      countryIds: $countries
      cityIds: $cities
      roleIds: $roles
      lobIds: $lobs
      isCoMoUser: $isCoMoUser
    ) {
      userId
    }
  }
`;

export const ALL_USERS_AND_GROUPS_IN_SURVEY = gql`
  query ($surveyId: Int!) {
    allUsersAndGroupsInSurvey(surveyId: $surveyId) {
      groups {
        code
        name
        countCient
      }
      totalUsers
      userIds
      userNames
    }
  }
`;

export const BULK_HISTORY_LIST = gql`
  query ($first: Int) {
    userBulkUploadAdminList(first: $first, order: { createDate: DESC }) {
      nodes {
        userBulkUploadId
        totalCreated
        totalUpdated
        totalDeleted
        totalFailed
        createUser
        createDate
        uploadStatusId
        elapsedTime
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      totalCount
    }
  }
`;

export const BULK_HISTORY_LIST_AFTER = gql`
  query ($after: String, $first: Int) {
    userBulkUploadAdminList(
      after: $after
      first: $first
      order: { createDate: DESC }
    ) {
      nodes {
        userBulkUploadId
        totalCreated
        totalUpdated
        totalDeleted
        totalFailed
        createUser
        createDate
        uploadStatusId
        elapsedTime
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      totalCount
    }
  }
`;

export const BULK_HISTORY_LIST_BEFORE = gql`
  query ($before: String, $last: Int) {
    userBulkUploadAdminList(
      before: $before
      last: $last
      order: { createDate: DESC }
    ) {
      nodes {
        userBulkUploadId
        totalCreated
        totalUpdated
        totalDeleted
        totalFailed
        createUser
        createDate
        uploadStatusId
        elapsedTime
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      totalCount
    }
  }
`;

export const ALL_RECURRENCE_CONFIGURATION = gql`
  query ($idSurvey: Int!) {
    allRecurrenceConfiguration(where: { idSurvey: { eq: $idSurvey } }) {
      idRecurrenceConfiguration
      idSurvey
      description
      period
      repeatEvery
      repeatOptions
      startOn
      startTime
      endOn
      endTime
      createUser
      createdDate
      lastUpdateUser
      lastUpdatedDate
      recordState
    }
  }
`;
export const RECURRENCE_CONFIGURATION_BY_ID = gql`
  query ($recurrenceConfigurationId: Int!) {
    recurrenceConfigurationById(
      recurrenceConfigurationId: $recurrenceConfigurationId
    ) {
      idRecurrenceConfiguration
      idSurvey
      description
      period
      repeatEvery
      repeatOptions
      startOn
      startTime
      endOn
      endTime
      lastUpdateUser
    }
  }
`;

export const SITES_ADMINISTRATOR = gql`
  query ($clientId: Int!, $searchBy: String!) {
    sitesAdministration(
      clientId: $clientId
      order: { siteName: ASC }
      searchBy: $searchBy
    ) {
      siteId
      siteName
      statusId
      createUser
      createDate
      city {
        cityName
        state {
          stateName
          country {
            countryName
          }
        }
      }
    }
  }
`;

export const LOBS_BY_CLIENT_WITH_USERS = gql`
  query ($clientId: Int!, $searchBy: String!) {
    lobsByClientWithUsers(clientId: $clientId, searchBy: $searchBy) {
      lobid
      name
      description
      statusId
      createDate
      createUser
      sitesLobs {
        idSite
        idSiteNavigation {
          siteId
          siteName
          cityId
          city {
            cityName
            state {
              country {
                countryName
              }
            }
          }
        }
      }
      usersInLob
    }
  }
`;

export const LOBS_LIST = gql`
  query (
    $countriesId: [Int!]
    $searchBy: String!
    $first: Int
    $after: String
    $before: String
    $last: Int
  ) {
    lobsAdminList(
      countriesId: $countriesId
      searchBy: $searchBy
      first: $first
      after: $after
      before: $before
      last: $last
      order: { lobId: DESC }
    ) {
      totalCount
      nodes {
        lobId
        lobName
        lobDescription
        enabled
        createDate
        createName
        country {
          countryId
          countryName
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`;

export const CAN_I_DISABLE_LOB = gql`
  query ($lobId: Int!) {
    canIDisableLob(lobId: $lobId)
  }
`;

export const ALL_SMILEYS = gql`
  query {
    allSmileys {
      outputData {
        idSmiley
        smileyFeel
        smileyIdentifier
        source
        recordState
        category
        triggerRequest
      }
      withError
      message
    }
  }
`;

export const ALL_REASONS = gql`
  query {
    allReasons {
      withError
      message
      outputData {
        id: idReason
        description: reasonDescription
        recordState
      }
    }
  }
`;

export const ALL_DETAILS_BY_REASON_ID = gql`
  query ($reasonId: Int!) {
    allDetailsByReasonId(reasonId: $reasonId) {
      withError
      message
      outputData {
        id: idReasonDetail
        idReason
        description: detailDescription
        recordState
      }
    }
  }
`;

export const ALL_RISK_WORDS = gql`
  query {
    allRiskWords {
      withError
      message
      outputData {
        idRiskWords
        phrase
        recordState
      }
    }
  }
`;

export const USERS_FEELING_BY_USER_AND_DATE = gql`
  query ($userId: Int!, $dateEntry: DateTime) {
    usersFeelingByUserAndDate(userId: $userId, dateEntry: $dateEntry) {
      withError
      message
      outputData {
        idUserFeeling
        idUser
        comment
        mailingWellness
        idReason
        createDate
      }
    }
  }
`;

export const USERS_FEELING_BY_USERID = gql`
  query ($userId: Int!) {
    usersFeelingByUserId(userId: $userId) {
      message
      outputData {
        idUser
        createDate
        createUser
        idSmiley
      }
      withError
    }
  }
`;

export const SMILEYS = gql`
  query {
    smileys {
      withError
      message
      outputData {
        idSmiley
        smileyFeel
        smileyIdentifier
        source
        recordState
      }
    }
  }
`;

export const MOOD_METER_GET_CONFIGURATION = gql`
  query {
    moodMeterGetConfiguration {
      withError
      message
      outputData {
        recordsPerDay
        intervalDuration
        questionForUser
      }
    }
  }
`;

export const ALL_WELLNESS_MAIL = gql`
  query {
    allWellnessMail {
      withError
      message
      outputData {
        idWellnessMail
        idUser
        recordState
        createDate
        createUser
      }
    }
  }
`;

export const ALL_WELLNESS_MAIL_BY_CITY = gql`
  query ($idCity: Int!) {
    allWellnessMailByCity(idCity: $idCity) {
      withError
      message
      outputData {
        idWellnessMail
        idUser
        recordState
        createDate
        createUser
      }
    }
  }
`;

export const ALL_WELLNESS_MAIL_CATCH_ALL = gql`
  query {
    allWellnessMailCatchAll {
      withError
      message
      outputData {
        idWellnessMail
        idUser
        recordState
        createDate
        createUser
      }
    }
  }
`;

export const USERS_BY_IDS = gql`
  query ($usersIds: [Int!]!) {
    userAdminlistByIds(userIds: $usersIds) {
      userId
      userFirstName
      userLastName
      userFullName
      userTpId
      userCcms
      enabled
    }
  }
`;

export const SURVEY_STATISTICS = gql`
  query ($surveyId: Int!) {
    surveyStatistics(surveyId: $surveyId) {
      withError
      message
      outputData {
        usersAssigned
        surveysResponded
        surveysRemaining
      }
    }
  }
`;

export const GRAPH_BY_SURVEY = gql`
  query (
    $surveyId: Int!
    $filterByLocation: Boolean!
    $initielDate: DateTime
    $finalDate: DateTime
    $lobs: [Int!]
    $site: Int
    $city: Int
    $state: Int
    $country: Int
  ) {
    graphsBySurvey2(
      input: {
        surveyId: $surveyId
        filterByLocation: $filterByLocation
        initialDate: $initielDate
        finalDate: $finalDate
        lobs: $lobs
        site: $site
        city: $city
        state: $state
        country: $country
      }
    ) {
      key
      value {
        questionName
        jsonConfiguration
        questionBankId
        totalAnswers
        answerOptions {
          optionAnswer
          totalAnswers
          percentage
        }
      }
    }
  }
`;

export const DOWNLOAD_ALL_ANSWER_SURVEY = gql`
  query (
    $surveyId: Int!
    $filterByLocation: Boolean!
    $initielDate: DateTime
    $finalDate: DateTime
    $lobs: [Int!]
    $site: Int
    $city: Int
    $state: Int
    $country: Int
    $surveyName: String
    $surveyNameHeader: Boolean!
    $userHeader: Boolean!
    $clientHeader: Boolean!
    $countryHeader: Boolean!
    $cityHeader: Boolean!
    $lobHeader: Boolean!
    $tpIdHeader: Boolean!
    $usernameHeader: Boolean!
    $answerDateHeader: Boolean!
    $activationDateHeader: Boolean!
    $userStatusHeader: Boolean!
    $roleHeader: Boolean!
  ) {
    downloadAllAnswersSurvey(
      input: {
        headers: {
          surveyName: $surveyNameHeader
          user: $userHeader
          client: $clientHeader
          country: $countryHeader
          city: $cityHeader
          lob: $lobHeader
          tpId: $tpIdHeader
          username: $usernameHeader
          answerDate: $answerDateHeader
          activationDate: $activationDateHeader
          userStatus: $userStatusHeader
          role: $roleHeader
        }
        filters: {
          surveyId: $surveyId
          filterByLocation: $filterByLocation
          initialDate: $initielDate
          finalDate: $finalDate
          lobs: $lobs
          site: $site
          city: $city
          state: $state
          country: $country
          surveyName: $surveyName
        }
      }
    ) {
      message
      withError
      outputData {
        headers
        answers {
          surveyName
          ccmsUser
          clientName
          countryName
          cityName
          lob
          email
          answerDate
          activationDate
          userStatus
          role
          answer
          user
          anonymousSurveyId
        }
      }
    }
  }
`;

export const DOWNLOAD_ALL_OPEN_TEXT_ANSWER_BY_QUESTION = gql`
  query (
    $questionBankId: Int!
    $filterByLocation: Boolean!
    $initielDate: DateTime
    $finalDate: DateTime
    $lobs: [Int!]
    $site: Int
    $city: Int
    $state: Int
    $country: Int
    $surveyName: String!
  ) {
    downloadAllOpenTextAnswersByQuestion(
      input: {
        questionBankId: $questionBankId
        filterByLocation: $filterByLocation
        initialDate: $initielDate
        finalDate: $finalDate
        lobs: $lobs
        site: $site
        city: $city
        state: $state
        country: $country
        surveyName: $surveyName
      }
    ) {
      message
      withError
      outputData {
        headers
        answers {
          surveyName
          ccmsUser
          clientName
          countryName
          cityName
          answer
        }
      }
    }
  }
`;

export const CURRENT_USER_SUPERVISOR = gql`
  query {
    currentUser {
      supervisorId
    }
  }
`;

export const CURRENT_USER_INFO = gql`
  query {
    currentUser {
      userId
      userFullName
      userCcms
      userTpId
      userEmail
      role {
        roleId
        roleName
      }
      location {
        clientName
        cityName
        countryName
        countryId
        cityId
      }
      lobs {
        lobName
      }
      enabled
    }
  }
`;

export const DOWNLOAD_FEEDBACKS_BYIDSURVEY = gql`
  query ($surveyId: Int!, $surveyName: String) {
    downloadFeedbacksByIdSurvey(
      input: { surveyId: $surveyId, surveyName: $surveyName }
    ) {
      message
      withError
      outputData {
        download {
          Survey_name: surveyName
          CCMS_user: ccms
          First_name: firstName
          Last_name: lastName
          Client_name: clientName
          Country_name: countryName
          Site_location: siteLocation
          Rating: rating
          Observations: observations
        }
      }
    }
  }
`;

export const AVERAGE_FEEDBACKS_BYIDSURVEY = gql`
  query ($surveyId: Int!, $surveyName: String) {
    downloadFeedbacksByIdSurvey(
      input: { surveyId: $surveyId, surveyName: $surveyName }
    ) {
      message
      withError
      outputData {
        average
        totalUsers
      }
    }
  }
`;

export const CITIES_BY_COUNTRY = gql`
  query ($countryId: Int!) {
    citiesByCountryId(countryId: $countryId) {
      message
      outputData {
        id: cityId
        name: cityName
        createUser
      }
      withError
    }
  }
`;

export const EVENT_BY_ID = gql`
  query ($eventId: Int!) {
    eventById(eventId: $eventId) {
      idEvent
      startDate
      finishDate
      eventName
      eventState
      eventType
      urlEvent
      urlPhoto
      description
      eventState
      idCategory
      idCity
      idCountry
      idLanguage
      participantsLimit
      totalGuests
      countryName
      cityName
      recurrenceEndDate
      recurrencePattern
      idCategoryNavigation {
        value: idCategory
        label: categoryName
      }
      idLanguageNavigation {
        value: idLanguage
        label: nativeName
      }
      wellnessParticipants {
        idEvent
        userId
        attendStatus
        isRequired
      }
      wellnessSpeakerEvents {
        idSpeaker
        idEvent
        idSpeakerNavigation {
          value: idSpeaker
          label: speakerName
          description
          urlPhoto
          position
          email
        }
      }
      wellnessEventsCriteria {
        value: idCriteria
        label: name
        idEvent
        idCountry
        recordStatus
        usersCount
      }
      wellnessSearchGroups {
        value: idSearchGroup
        label: name
        idEvent
        groupStatus
        usersCount
      }
      wellnessSearchGroupUsers {
        idSearchgroupUser
        idEvent
        idUser
        idSearchGroup
        user {
          userId
          firstName
          lastName
          emailAddress
        }
      }
    }
  }
`;

export const ALL_EVENTS = gql`
  query {
    allEvents {
      nodes {
        idEvent
        eventName
        description
        eventType
        urlEvent
        startDate
        finishDate
        urlPhoto
      }
    }
  }
`;

export const ALL_CATEGORIES_CALENDAR = gql`
  query {
    allCategories(where: { recordState: { eq: "Active" } }) {
      idCategory
      categoryName
      codeColor
      recordState
    }
  }
`;

export const ALL_CATEGORIES = gql`
  query {
    allCategories(
      where: { recordState: { eq: "Active" }, and: { idCategory: { neq: 1 } } }
    ) {
      idCategory
      categoryName
      codeColor
      recordState
    }
  }
`;

export const ALL_ADMIN_CATEGORIES = gql`
  query ($searchBy: String) {
    allCategories(searchBy: $searchBy) {
      idCategory
      categoryName
      codeColor
      recordState
      createDate
      createUser
    }
  }
`;

export const EVENT_CALENDAR_FILTERED = gql`
  query (
    $idCategory: [Int!]
    $userId: Int!
    $startSearch: DateTime!
    $endSearch: DateTime!
  ) {
    myCalendar(
      userId: $userId
      where: { idCategory: { in: $idCategory } }
      startSearch: $startSearch
      endSearch: $endSearch
    ) {
      idEvent
      eventName
      description
      startDate
      finishDate
      idCategoryNavigation {
        codeColor
        categoryName
      }
      wellnessParticipants {
        userId
        attendStatus
      }
    }
  }
`;

export const FIRTS_LIVE_EVENTS_CALENDAR = gql`
  query (
    $userId: Int!
    $startDate: DateTime!
    $finishDate: DateTime!
    $first: Int!
  ) {
    allEvents(
      first: $first
      where: {
        wellnessParticipants: {
          none: {
            userId: { eq: $userId }
            and: { attendStatus: { eq: "Accept" } }
          }
        }
        and: {
          startDate: { lte: $startDate }
          and: {
            finishDate: { gte: $finishDate }
            and: { eventType: { eq: "Public" } }
          }
        }
      }
    ) {
      edges {
        cursor
        node {
          idEvent
          eventName
          description
          startDate
          finishDate
          eventType
          wellnessParticipants {
            userId
            attendStatus
          }
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`;

export const AFTER_LIVE_EVENTS_CALENDAR = gql`
  query (
    $userId: Int!
    $startDate: DateTime!
    $finishDate: DateTime!
    $after: String!
    $first: Int!
  ) {
    allEvents(
      first: $first
      after: $after
      where: {
        wellnessParticipants: { none: { userId: { eq: $userId } } }
        and: {
          startDate: { lte: $startDate }
          and: {
            finishDate: { gte: $finishDate }
            and: { eventType: { eq: "Public" } }
          }
        }
      }
    ) {
      edges {
        cursor
        node {
          idEvent
          eventName
          description
          startDate
          finishDate
          eventType
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`;
export const LIST_EVENTS_FIRST = gql`
  query (
    $first: Int!
    $startDate: DateTime
    $finishDate: DateTime
    $countriesId: [Int!]
    $citiesId: [Int!]
    $categoryId: Int
    $searchBy: String
    $eventType: String
  ) {
    allEventsList(
      first: $first
      startDate: $startDate
      finishDate: $finishDate
      countriesId: $countriesId
      citiesId: $citiesId
      categoryId: $categoryId
      searchBy: $searchBy
      eventType: $eventType
      order: { idEvent: DESC }
    ) {
      totalCount
      nodes {
        idEvent
        eventName
        description
        idCategory
        idCategoryNavigation {
          idCategory
          categoryName
        }
        createDate
        startDate
        finishDate
        createUser
        eventState
        participantsLimit
        wellnessParticipants {
          attendStatus
          userId
          recordState
        }
        wellnessEventFeedbacks {
          rating
          idUser
          observations
        }
        eventType
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`;
export const LIST_EVENTS_AFTER = gql`
  query (
    $first: Int!
    $after: String
    $startDate: DateTime
    $finishDate: DateTime
    $countriesId: [Int!]
    $citiesId: [Int!]
    $categoryId: Int
    $searchBy: String
    $eventType: String
  ) {
    allEventsList(
      first: $first
      after: $after
      startDate: $startDate
      finishDate: $finishDate
      countriesId: $countriesId
      citiesId: $citiesId
      categoryId: $categoryId
      searchBy: $searchBy
      eventType: $eventType
      order: { idEvent: DESC }
    ) {
      totalCount
      nodes {
        idEvent
        eventName
        description
        idCategory
        idCategoryNavigation {
          idCategory
          categoryName
        }
        createDate
        startDate
        finishDate
        createUser
        eventState
        participantsLimit
        wellnessParticipants {
          attendStatus
          userId
          recordState
        }
        wellnessEventFeedbacks {
          rating
          idUser
          observations
        }
        eventType
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`;
export const LIST_EVENTS_BEFORE = gql`
  query (
    $last: Int!
    $before: String!
    $startDate: DateTime
    $finishDate: DateTime
    $countriesId: [Int!]
    $citiesId: [Int!]
    $categoryId: Int
    $searchBy: String
    $eventType: String
  ) {
    allEventsList(
      last: $last
      before: $before
      startDate: $startDate
      finishDate: $finishDate
      countriesId: $countriesId
      citiesId: $citiesId
      categoryId: $categoryId
      searchBy: $searchBy
      eventType: $eventType
      order: { idEvent: DESC }
    ) {
      totalCount
      nodes {
        idEvent
        eventName
        description
        idCategory
        idCategoryNavigation {
          idCategory
          categoryName
        }
        createDate
        startDate
        finishDate
        createUser
        eventState
        participantsLimit
        wellnessParticipants {
          attendStatus
          userId
          recordState
        }
        wellnessEventFeedbacks {
          rating
          idUser
          observations
        }
        eventType
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`;

export const ALL_LANGUAGES = gql`
  query(
    $first: Int
    $after: String
  ) {
    allLanguages(
      first: $first
      after: $after
    ) {
      nodes {
        id: idLanguage
        language
        name: nativeName
        urlFlag
        status
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`;

export const ALL_SPEAKERS = gql`
  query {
    allSpeakers {
      id: idSpeaker
      name: speakerName
      email
      description
      urlPhoto
      position
    }
  }
`;
export const GET_CONFIGURATION = gql`
  query ($key: String!) {
    configurationByKey(key: $key) {
      value
    }
  }
`;
export const GET_MENU_BY_ROLE = gql`
  query {
    menuByRole {
      menuId
      route
      title
      icon
      color
      idParentMenu
      link
      groupMenu
      menuPosition
      topBanner
    }
  }
`;
export const GET_GUESTS_FIRST = gql`
  query ($input: ParticipantQueryInput, $first: Int!) {
    allParticipantsByEvent(input: $input, first: $first) {
      edges {
        cursor
        node {
          userId
          attendStatus
          attendanceCheck
          firstName
          lastName
          email
          countryIsoCode
          cityName
          registrationDate
          isDeletedUser
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      totalCount
    }
  }
`;
export const GET_GUESTS_AFTER = gql`
  query ($input: ParticipantQueryInput, $first: Int!, $after: String) {
    allParticipantsByEvent(input: $input, first: $first, after: $after) {
      edges {
        cursor
        node {
          userId
          attendStatus
          attendanceCheck
          firstName
          lastName
          email
          countryIsoCode
          cityName
          registrationDate
          isDeletedUser
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      totalCount
    }
  }
`;
export const GET_GUESTS_BEFORE = gql`
  query ($input: ParticipantQueryInput, $last: Int!, $before: String!) {
    allParticipantsByEvent(input: $input, last: $last, before: $before) {
      edges {
        cursor
        node {
          userId
          attendStatus
          attendanceCheck
          firstName
          lastName
          email
          countryIsoCode
          cityName
          registrationDate
          isDeletedUser
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      totalCount
    }
  }
`;
export const GET_EVENT_STATUS = gql`
  query {
    allAttendStatus {
      description
    }
  }
`;

export const ALL_PUBLIC_EVENT_LIST = gql`
  query (
    $languagesId: [String]
    $speakersId: [Int!]
    $categoryId: Int
    $searchBy: String
    $startDate: DateTime
    $finishDate: DateTime
    $first: Int
    $last: Int
    $after: String
    $before: String
  ) {
    allPublicEventsList(
      languagesId: $languagesId
      speakersId: $speakersId
      categoryId: $categoryId
      searchBy: $searchBy
      startDate: $startDate
      finishDate: $finishDate
      first: $first
      after: $after
      last: $last
      before: $before
    ) {
      nodes {
        idEvent
        createUser
        eventName
        description
        eventState
        eventType
        urlPhoto
        participantsLimit
        startDate
        finishDate
        idCategory
        idLanguage
        idCity
        idCountry
        urlEvent
        urlPhoto
        totalAccepted
        totalGuests
        isFull
        recurrenceEndDate
        recurrencePattern
        wellnessSpeakerEvents {
          idSpeaker
          idSpeakerNavigation {
            idSpeaker
            speakerName
            position
          }
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
      totalCount
    }
  }
`;

export const ABOUT_USER = gql`
  query ($usersIds: [Int!]!) {
    userAdminlistByIds(userIds: $usersIds) {
      userId
      userFirstName
      userLastName
      userTpId
      userEmail
      location {
        countryId
        countryName
        cityId
        cityName
      }
    }
  }
`;
export const GET_DATA_COACH = gql`
  query ($idCoach: Int!) {
    wellnessCoachById(where: { idCoach: { eq: $idCoach } }) {
      userId
      firstName: cFirstName
      lastName: cLastName
      email: cMailBox
      countryName: cCountryName
      cityName: cCityName
      position
      yearsInTp
      description
      coverImage
      yearsOfExperience
      wellnessCoachesLanguages {
        idLanguage
        idLanguageNavigation {
          language
        }
      }
      wellnessCoachesWorkhours {
        weekday
        startTime
        finishTime
      }
    }
  }
`;
export const GET_COACHES = gql`
  query ($input: CoachesQueryInput) {
    wellnessCoachesAdmin(input: $input) {
      userId
      cFirstName
      cLastName
      cMailBox
      cCountryName
      cCityName
      coachState
      agentsAssigned
      idCoach
    }
  }
`;
export const GET_CLIENTS_ACCOUNTS = gql`
  query ($clientId: Int!) {
    clientList(where: { clientId: { neq: $clientId } }) {
      id: clientId
      name: clientName
      languageId
      languageName
      logo: logoName
    }
  }
`;
export const GET_CLIENTS = gql`
  query {
    clientList {
      clientId
      clientName
      languageId
      languageName
      logoName
    }
  }
`;
export const ALL_MY_COACH = gql`
  query ($searchBy: String, $startDate: DateTime, $finishDate: DateTime) {
    allMyCoaches(
      searchBy: $searchBy
      startDate: $startDate
      finishDate: $finishDate
    ) {
      idCoach
      coachState
      userId
      userStatus
      firstName
      lastName
      description
      coverImage
      position
      turnsAvailable {
        start
        end
      }
      turnsTaken {
        start
        end
      }
      yearsOfExperience
      yearsInTp
      emailAddress
      cityId
      cityName
      countryId
      countryName
      agentsAssigned
      wellnessCoachesLanguages {
        idLanguage
      }
      wellnessCoachesWorkhours {
        idCoach
        idWeeklyHour
        startTime
        finishTime
        weekday
      }
    }
  }
`;

export const ABOUTME = gql`
  query {
    aboutMe {
      userId
      firstName
      lastName
      countryId
      countryName
      cityId
      cityName
      emailAddress
    }
  }
`;

export const COACH_AVAILABILITY = gql`
  query ($coachId: Int!, $startDate: DateTime!, $finishDate: DateTime!) {
    coachAvailability(
      coachId: $coachId
      startDate: $startDate
      finishDate: $finishDate
    ) {
      idCoach
      coachState
      userId
      userStatus
      firstName
      lastName
      description
      coverImage
      position
      turnsAvailable {
        start
        end
      }
      turnsTaken {
        start
        end
      }
      yearsOfExperience
      yearsInTp
      emailAddress
      cityId
      cityName
      countryId
      countryName
      wellnessCoachesLanguages {
        idLanguage
        idLanguageNavigation {
          language
          idLanguage
          nativeName
        }
      }
      wellnessCoachesWorkhours {
        idCoach
        idWeeklyHour
        startTime
        finishTime
        weekday
      }
    }
  }
`;

export const ALL_MY_SPACES = gql`
  query ($startDate: DateTime, $finishDate: DateTime, $searchBy: String) {
    allMySpaces(
      startDate: $startDate
      finishDate: $finishDate
      searchBy: $searchBy
      where: { recordState: { eq: "Active" } }
    ) {
      idSpace
      name
      topic
      description
      coverImageSrc
      url
      idCountry
      countryName
      idCity
      cityName
      startDate
      finishDate
      createUser
      recordState
    }
  }
`;

// query ($startDate: DateTime, $finishDate: DateTime, $searchBy: String) {
//   allMySpaces(
//     startDate: $startDate
//     finishDate: $finishDate
//     searchBy: $searchBy
//   ) {
//     idSpace
//     name
//     topic
//     description
//     coverImageSrc
//     url
//     idCountry
//     countryName
//     idCity
//     cityName
//     startDate
//     finishDate
//     createUser
//     recordState
//   }
// }

export const ALL_MY_SPACES_MANAGEMENT = gql`
  query ($countryId: Int, $cityId: Int, $searchBy: String, $first: Int!) {
    spacesAdministration(
      input: { countryId: $countryId, cityId: $cityId, searchBy: $searchBy }
      first: $first
      order: { idSpace: DESC }
    ) {
      pageInfo {
        hasPreviousPage
        hasNextPage
        startCursor
        endCursor
      }
      edges {
        node {
          idSpace
          name
          topic
          createUser
          countryName
          cityName
          recordState
        }
      }
      totalCount
    }
  }
`;

export const ALL_MY_SPACES_MANAGEMENT_AFTER = gql`
  query (
    $countryId: Int
    $cityId: Int
    $searchBy: String
    $after: String
    $first: Int!
  ) {
    spacesAdministration(
      input: { countryId: $countryId, cityId: $cityId, searchBy: $searchBy }
      after: $after
      first: $first
      order: { idSpace: DESC }
    ) {
      pageInfo {
        hasPreviousPage
        hasNextPage
        startCursor
        endCursor
      }
      edges {
        node {
          idSpace
          name
          topic
          createUser
          countryName
          cityName
          recordState
        }
      }
      totalCount
    }
  }
`;

export const ALL_MY_SPACES_MANAGEMENT_BEFORE = gql`
  query (
    $countryId: Int
    $cityId: Int
    $searchBy: String
    $before: String
    $last: Int!
  ) {
    spacesAdministration(
      input: { countryId: $countryId, cityId: $cityId, searchBy: $searchBy }
      before: $before
      last: $last
      order: { idSpace: DESC }
    ) {
      pageInfo {
        hasPreviousPage
        hasNextPage
        startCursor
        endCursor
      }
      edges {
        node {
          idSpace
          name
          topic
          createUser
          countryName
          cityName
          recordState
        }
      }
      totalCount
    }
  }
`;

export const ALL_MY_SPACES_BY_ID = gql`
  query ($idSpace: Int!) {
    spaceById(where: { idSpace: { eq: $idSpace } }) {
      idSpace
      name
      topic
      description
      coverImageSrc
      url
      idCountry
      countryName
      idCity
      cityName
      startDate
      finishDate
      createUser
      recordState
      wellnessSpacesSearchsResults {
        userId
        name
        isGroup
      }
    }
  }
`;

export const ALL_MY_GAMES_BY_ID = gql`
  query ($gameId: Int!) {
    gameById(where: { gameId: { eq: $gameId } }) {
      gameId
      name
      startDate
      endDate
      topic
      description
      url
      coverImage
      wellnessGameGroups {
        name
        wellnessGameGroupId
        wellnessGameUsers {
          userId
        }
      }
    }
  }
`;

export const GAME_USERS = gql`
  query ($gameId: Int!) {
    usersByGameId(gameId: $gameId) {
      userId
      firstName
      lastName
    }
  }
`;

export const ALL_HOME_CONFIGURATIONS = gql`
  query {
    allConfigurationValues {
      keyConfigurationValues
      descriptionConfigurationValues
      value
      section
    }
  }
`;

export const MY_GAMES = gql`
  query ($finalDate: DateTime!, $initialDate: DateTime!, $searchBy: String) {
    myGames(
      queryParams: {
        initialDate: $initialDate
        finalDate: $finalDate
        searchBy: $searchBy
      }
    ) {
      nodes {
        name
        description
        topic
        endDate
        createdByName
        coverImage
        url
        status
        startDate
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`;

export const ALL_MY_GAMES_ADMIN_FIRST = gql`
  query ($searchBy: String, $first: Int!) {
    gamesAdministration(
      queryParams: { searchBy: $searchBy }
      first: $first
      order: { gameId: DESC }
    ) {
      totalCount
      edges {
        cursor
        node {
          gameId
          name
          description
          topic
          createUser
          usersAssigned
          status
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`;

export const ALL_MY_GAMES_ADMIN_AFTER = gql`
  query ($searchBy: String, $after: String, $first: Int) {
    gamesAdministration(
      queryParams: { searchBy: $searchBy }
      after: $after
      first: $first
      order: { gameId: DESC }
    ) {
      totalCount
      edges {
        cursor
        node {
          gameId
          name
          description
          topic
          createUser
          usersAssigned
          status
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`;

export const ALL_MY_GAMES_ADMIN_BEFORE = gql`
  query ($searchBy: String, $before: String, $last: Int) {
    gamesAdministration(
      queryParams: { searchBy: $searchBy }
      before: $before
      last: $last
      order: { gameId: DESC }
    ) {
      totalCount
      edges {
        cursor
        node {
          gameId
          name
          description
          topic
          createUser
          usersAssigned
          status
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      totalCount
    }
  }
`;

export const USERS_GROUPS_BY_APPROVER_ID = gql`
  query ($approverId: Int!) {
    usersGroupsByApproverId(approverId: $approverId) {
      outputData {
        users {
          userId
          userName
        }
        groups {
          groupId
          groupName
          usersInGroup
        }
      }
    }
  }
`;

export const APPROVER_COMMENTS_BY_SURVEY_ID = gql`
  query ($surveyId: Int!) {
    approverCommentsBySurveyId(surveyId: $surveyId) {
      message
      outputData {
        comment
        idApprover
        idApproverComment
        idSurvey
        createUser
        createDate
        solved
      }
      withError
    }
  }
`;

export const ALL_EMAIL_TEMPLATES = gql`
  query {
    allEmailTemplates {
      idEmailTemplate
      name
      description
      recordState
      createDate
      emailBody
      emailSubject
      templateCode
      allCountries
      idCountry
      countryName
    }
  }
`;

export const SURVEYS_BY_STATES_ID = gql`
  query (
    $surveyStateIds: [Int!]
    $searchBy: String
    $first: Int
    $last: Int
    $after: String
    $before: String
  ) {
    allSurveysByUserRole(
      searchBy: $searchBy
      surveyStateIds: $surveyStateIds
      first: $first
      after: $after
      last: $last
      before: $before
      order: { idSurvey: DESC }
    ) {
      totalCount
      nodes {
        idSurvey
        surveyName
        surveyDescription
        idSurveyState
        activateSurveyDate
        createUser
        countryId
      }
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;

export const IS_APPROVER_FOR_SURVEY = gql`
  query ($surveyId: Int!) {
    isApproverForSurvey(surveyId: $surveyId) {
      message
      outputData {
        isApproved
      }
      withError
    }
  }
`;

export const GET_QUESTIONS_IN_BANK = gql`
  query ($idcategoryQuestion: Int!, $searchBy: String, $first: Int) {
    questionsInBankByCategory(
      first: $first
      input: { categoryId: $idcategoryQuestion, searchBy: $searchBy }
    ) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          idQuestionNavigation {
            nameQuestion
            validationText
            idCategoryQuestion
          }
          isMandatory
          idQuestionSurvey
          idQuestion
          active
          jsonConfiguration
        }
      }
    }
  }
`;

export const GET_QUESTIONS_IN_BANK_AFTER = gql`
  query (
    $idcategoryQuestion: Int!
    $searchBy: String
    $first: Int
    $after: String
  ) {
    questionsInBankByCategory(
      first: $first
      after: $after
      input: { categoryId: $idcategoryQuestion, searchBy: $searchBy }
    ) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          idQuestionNavigation {
            nameQuestion
            validationText
            idCategoryQuestion
          }
          isMandatory
          idQuestionSurvey
          idQuestion
          active
          jsonConfiguration
        }
      }
    }
  }
`;

export const DOWNLOAD_USERS = gql`
  query (
    $clientId: Int!
    $countries: [Int!]
    $states: [Int!]
    $cities: [Int!]
    $clientSite: [Int!]
    $roles: [Int!]
    $lobs: [Int!]
    $userHeader: Boolean!
    $clientHeader: Boolean!
    $countryHeader: Boolean!
    $cityHeader: Boolean!
    $roleHeader: Boolean!
    $lobHeader: Boolean!
    $tpIdHeader: Boolean!
    $userNameHeader: Boolean!
    $statusHeader: Boolean!
  ) {
    downloadUsers(
      input: {
        filters: {
          clientId: $clientId
          countries: $countries
          states: $states
          cities: $cities
          clientSite: $clientSite
          roles: $roles
          lobs: $lobs
        }
        headers: {
          user: $userHeader
          client: $clientHeader
          country: $countryHeader
          city: $cityHeader
          role: $roleHeader
          lob: $lobHeader
          tpId: $tpIdHeader
          userName: $userNameHeader
          status: $statusHeader
        }
      }
    ) {
      headers
      users {
        firstName
        lastName
        ccmsUser
        role
        country
        city
        lob
        status
        tpId
        client
      }
    }
  }
`;

export const ALL_SURVEY_TEMPLATE = gql`
  query {
    allSurveyTemplates {
      idSurveyTemplate
      templateName
      idSurvey
    }
  }
`;

export const DOWNLOAD_ATTENDEES = gql`
  query ($eventId: Int!) {
    downloadAttendees(eventId: $eventId) {
      headers
      answers {
        firstName
        lastName
        ccmsUser
        email
        country
        city
        registrationDate
        checkInState
        attended
      }
    }
  }
`;

export const RESOURCE_LIST_BY_MODULE = gql`
  query ($categoryName: String!) {
    resourceListByModule(categoryName: $categoryName) {
      fileName
      resourceName
    }
  }
`;

export const GET_EVENTS_NOT_RATED = gql`
  query {
    eventsNonRatedByUser {
      idEvent
      eventName
      description
    }
  }
`;

export const GET_CLIENT_STATS = gql`
  query {
    clientCount {
      clientsCount
      agentsCount
    }
  }
`;

export const SURVEY_METRICS = gql`
  query {
    surveyMetrics {
      name
      value
      unit
    }
  }
`;

export const WELLNESS_METRICS = gql`
  query {
    wellnessMetrics {
      name
      value
      unit
    }
  }
`;

export const FORMS = gql`
  query (
    $search: String!
    $first: Int
    $after: String
    $last: Int
    $before: String
  ) {
    formAdminList(
      search: $search
      first: $first
      after: $after
      before: $before
      last: $last
      order: { idForm: DESC }
    ) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      totalCount
      nodes {
        idForm
        name
        idCity
        city {
          countryName
          cityName
          cityId
          cityName
          countryId
          countryName
          stateId
          stateName
        }
        description
        jsonConfiguration
        recordStatus
        creationDate
        policyFormsLobs {
          idLob
        }
        lobs {
          name
          lobid
        }
      }
    }
  }
`;

export const FORM_BY_ID = gql`
  query ($idForm: Int!) {
    formById(where: { idForm: { eq: $idForm } }) {
      idForm
      idCity
      city {
        countryName
        cityName
      }
      name
      description
      recordStatus
      creationDate
      policyFormsLobs {
        idLob
      }
      lobs {
        name
      }
    }
  }
`;

export const GET_FORM_QUESTIONS = gql`
  query ($idForm: Int!) {
    formQuestionsByIdForm(idForm: $idForm) {
      idQuestionForm
      questionType
      isMandatory
      jsonConfiguration
      questionOrder
      questionTitle
      idFormNavigation {
        idForm
        name
        description
      }
    }
  }
`;

export const FORM_QUESTIONS_BY_ID_FORM = gql`
  query ($idForm: Int!) {
    formQuestionsByIdForm(idForm: $idForm) {
      edges {
        node {
          idQuestionForm
          questionTitle
          questionType
          recordStatus
          jsonConfiguration
          questionOrder
          isMandatory
          idFormNavigation {
            idForm
            name
            description
          }
          recordStatusNavigation {
            statusId
            recordStatus
          }
        }
      }
    }
  }
`;

export const FORM_QUESTIONS_BY_ID_QUESTION = gql`
  query ($idFormQuestion: Int!) {
    formQuestionsByIdQuestion(idFormQuestion: $idFormQuestion) {
      idQuestionForm
      questionTitle
      questionType
      recordStatus
      jsonConfiguration
      questionOrder
      isMandatory
      idFormNavigation {
        idForm
        name
        description
      }
      recordStatusNavigation {
        statusId
        recordStatus
      }
    }
  }
`;

export const FORMS_BY_USER_PROFILE = gql`
  query {
    formsByUserProfile {
      idForm
      name
      idCity
      description
      jsonConfiguration
    }
  }
`;
export const ALL_COUNTRIES = gql`
  query {
    allCountries {
      countryId
      countryName
      createuser
      createDate
      states {
        stateId
        stateName
      }
    }
  }
`;

export const CITIES_BY_COUNTRY_ID = gql`
  query ($countryId: Int!) {
    citiesByCountryId(countryId: $countryId) {
      outputData {
        cityId
        cityName
      }
    }
  }
`;

export const CASES_BY_USER_PROFILE_FIRST = gql`
  query (
    $searchBy: String
    $caseStatusId: Int
    $date: DateTime
    $hightPriority: Boolean
    $first: Int
  ) {
    casesByUserProfile(
      searchBy: $searchBy
      caseStatusId: $caseStatusId
      date: $date
      hightPriority: $hightPriority
      first: $first
      order: { idCase: DESC }
    ) {
      nodes {
        idCase
        idForm
        status
        handlerUser
        highPriority
        highPriorityReasons
        hasAttachment
        handlerUserInfo {
          firstName
          lastName
          userId
          ccmsuser
        }
        idFormNavigation {
          name
        }
        createDate
        createUser
        policyCaseComments {
          idCaseComment
          comment
        }
        totalComments
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
      totalCount
    }
  }
`;

export const CASES_BY_USER_PROFILE_AFTER = gql`
  query (
    $searchBy: String
    $caseStatusId: Int
    $date: DateTime
    $hightPriority: Boolean
    $first: Int
    $after: String
  ) {
    casesByUserProfile(
      searchBy: $searchBy
      caseStatusId: $caseStatusId
      date: $date
      hightPriority: $hightPriority
      first: $first
      after: $after
      order: { idCase: DESC }
    ) {
      nodes {
        idCase
        idForm
        status
        handlerUser
        highPriority
        highPriorityReasons
        hasAttachment
        handlerUserInfo {
          firstName
          lastName
          userId
          ccmsuser
        }
        idFormNavigation {
          name
        }
        createDate
        createUser
        policyCaseComments {
          idCaseComment
          comment
        }
        totalComments
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
      totalCount
    }
  }
`;

export const CASES_BY_USER_PROFILE_BEFORE = gql`
  query (
    $searchBy: String
    $caseStatusId: Int
    $date: DateTime
    $hightPriority: Boolean
    $last: Int
    $before: String
  ) {
    casesByUserProfile(
      searchBy: $searchBy
      caseStatusId: $caseStatusId
      date: $date
      hightPriority: $hightPriority
      last: $last
      before: $before
      order: { idCase: DESC }
    ) {
      nodes {
        idCase
        idForm
        status
        handlerUser
        highPriority
        highPriorityReasons
        hasAttachment
        handlerUserInfo {
          firstName
          lastName
          userId
          ccmsuser
        }
        idFormNavigation {
          name
        }
        createDate
        createUser
        policyCaseComments {
          idCaseComment
          comment
        }
        totalComments
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
      totalCount
    }
  }
`;

export const CASE_BY_ID = gql`
  query ($caseById: Int!) {
    caseById(caseId: $caseById) {
      idCase
      status
      createDate
      createUser
      handlerUserInfo {
        firstName
        lastName
      }
      idFormNavigation {
        idForm
        name
        description
        policyFormQuestions {
          idQuestionForm
          questionTitle
          questionType
        }
      }
      policyCaseComments {
        idCaseComment
        comment
      }
      totalComments
      policyQuestionAnswers {
        idQuestionAnswer
        idCase
        idQuestionForm
        idQuestionFormNavigation {
          questionTitle
        }
        answer
        base64FileContent
      }
    }
  }
`;

export const CASE_STATUSES = gql`
  query {
    caseStatuses {
      idCaseStatus
      statusName
      description
    }
  }
`;

export const COMMENTS_BY_CASE_ID = gql`
  query ($idCase: Int!) {
    commentsByCaseId(idCase: $idCase) {
      idCaseComment
      idCase
      comment
      ilike
      smiley
      createDate
      createUser
      createUserInfo {
        userId
        firstName
        lastName
        emailAddress
        ccmsuser
      }
      isOwnerCase
    }
  }
`;

export const CASES_BY_MANAGER_PROFILE_FIRST = gql`
  query (
    $searchBy: String
    $caseStatusId: Int
    $date: DateTime
    $hightPriority: Boolean
    $first: Int
  ) {
    casesByManagerProfile(
      searchBy: $searchBy
      caseStatusId: $caseStatusId
      date: $date
      hightPriority: $hightPriority
      first: $first
      order: { idCase: DESC }
    ) {
      nodes {
        idCase
        status
        createDate
        createUser
        idForm
        totalComments
        highPriority
        highPriorityReasons
        hasAttachment
        handlerUser
        handlerUserInfo {
          ccmsuser
        }
        idFormNavigation {
          name
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
      totalCount
    }
  }
`;

export const CASES_BY_MANAGER_PROFILE_AFTER = gql`
  query (
    $searchBy: String
    $caseStatusId: Int
    $date: DateTime
    $hightPriority: Boolean
    $first: Int
    $after: String
  ) {
    casesByManagerProfile(
      searchBy: $searchBy
      caseStatusId: $caseStatusId
      date: $date
      hightPriority: $hightPriority
      first: $first
      after: $after
      order: { idCase: DESC }
    ) {
      nodes {
        idCase
        status
        createDate
        createUser
        idForm
        totalComments
        highPriority
        highPriorityReasons
        hasAttachment
        handlerUser
        handlerUserInfo {
          ccmsuser
        }
        idFormNavigation {
          name
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
      totalCount
    }
  }
`;

export const CASES_BY_MANAGER_PROFILE_BEFORE = gql`
  query (
    $searchBy: String
    $caseStatusId: Int
    $date: DateTime
    $hightPriority: Boolean
    $last: Int
    $before: String
  ) {
    casesByManagerProfile(
      searchBy: $searchBy
      caseStatusId: $caseStatusId
      date: $date
      hightPriority: $hightPriority
      last: $last
      before: $before
      order: { idCase: DESC }
    ) {
      nodes {
        idCase
        status
        createDate
        createUser
        idForm
        totalComments
        highPriority
        highPriorityReasons
        hasAttachment
        handlerUser
        handlerUserInfo {
          ccmsuser
        }
        idFormNavigation {
          name
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
      totalCount
    }
  }
`;

export const NEXT_CASE_STATUSES_BY_CASE = gql`
  query ($caseId: Int!) {
    nextCaseStatusesByCase(caseId: $caseId) {
      idCaseStatus
      statusName
      description
    }
  }
`;

export const NEXT_CASE_STATUSES = gql`
  query ($caseStatusId: Int!) {
    nextCaseStatuses(caseStatusId: $caseStatusId) {
      idCaseStatus
      statusName
      description
    }
  }
`;

export const GET_POLICIES_ADMIN = gql`
  query ($first: Int, $after: String, $before: String, $searchText: String) {
    policies(
      first: $first
      after: $after
      before: $before
      search: $searchText
      order: { createDate: DESC }
    ) {
      totalCount
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      nodes {
        idPolicy
        policyName
        createUser
        createUserInfo {
          emailAddress
        }
        createDate
        recordStatus
        policyPoliciesLobs {
          idLob
        }
        lobs {
          lobid
          name
          statusId
        }
      }
    }
  }
`;

export const GET_QUEUES_ADMIN = gql`
  query ($first: Int, $after: String, $before: String, $search: String) {
    queues(
      first: $first
      after: $after
      before: $before
      search: $search
      order: { createDate: DESC }
    ) {
      totalCount
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      nodes {
        idQueue
        queueName
        recordStatus
        policyQueuesLobs {
          idLob
        }
        lobs {
          lobid
          name
          statusId
        }
        createUser
        createUserInfo {
          emailAddress
        }
        createDate
      }
    }
  }
`;

export const POLICIES_BY_CASE = gql`
  query ($caseId: Int!) {
    policiesByCase(caseId: $caseId) {
      idMainPolicy
      policyName
    }
  }
`;

export const SUBPOLICIES_BY_MAIN_POLICY = gql`
  query ($caseId: Int!, $policyId: Int!) {
    subPoliciesByMainPolicy(caseId: $caseId, policyId: $policyId) {
      idSubPolicy
      subPolicyName
    }
  }
`;

export const QUEUES_BY_CASE = gql`
  query ($caseId: Int!, $first: Int) {
    queuesByCase(caseId: $caseId, first: $first) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          idQueue
          queueName
        }
      }
      nodes {
        idQueue
        queueName
      }
    }
  }
`;

export const ICE_CONTACT_BY_CITY = gql`
  query ($idCity: Int!) {
    iceContactByCity(idCity: $idCity) {
      userId
      firstName
      lastName
      emailAddress
    }
  }
`;

export const ICE_IS_THERE_CITY_CONTACTS = gql`
  query{
    iceIsThereCityContacts
  }
`

export const PERMISSIONS_BY_CASE = gql`
  query ($caseId: Int!) {
    permissionsByCase(caseId: $caseId) {
      actionName
    }
  }
`;

export const ICE_NOTIFICATION_TEMPLATE = gql`
  query {
    emailTemplateById(emailTemplate: ICE_ALERT) {
      idEmailTemplate
      name
      description
      emailSubject
      emailBody
    }
  }
`;

export const ADDITIONAL_DATA_BY_CASE_ID = gql`
  query ($caseId: Int!) {
    additionalDataByCaseId(where: { idCase: { eq: $caseId } }) {
      idCase
      idAdditionalDataQuestion
      additionalDataAnswer
      idAdditionalDataQuestionNavigation {
        title
      }
    }
  }
`;

export const INSIGHT_POCS_LIST = gql`
  query {
    insightPocsList {
      policyInsightPocId
      policyInsightName
    }
  }
`;

export const GET_INSTANT_MESSAGES = gql`
  query {
    instantMessages {
      instanceMessageId
      message
      createdDate
    }
  }
`;

export const GET_ICE_BUTTON_STATUS = gql`
  query {
    iceRequestButtonStatusByUser
  }
`;

export const ICE_REQUEST_BY_WELLNESS_CITY = gql`
  query {
    iceRequestByWellnessCity {
      iceRequestId
      name
      location
      tpId
      ack
      dateTime
    }
  }
`;

export const INSTANT_MESSAGES = gql`
  query {
    instantMessages {
      instanceMessageId
      message
      createdUser
      createdDate
      status
    }
  }
`;

export const ADDITIONAL_DATA_LISTS = gql`
  query {
    additionalDataLists {
      idPolicyFormAdditionalDataList
      listTitle
    }
  }
`;

export const ADDITIONAL_DATA_QUESTIONS_BY_FORM = gql`
  query ($formId: Int!) {
    additionalDataQuestionsByForm(formId: $formId) {
      idFormAdditionalDataQuestion
      idForm
      idAdditionalDataList
      isMandatory
      title
      userId
      createDate
      questionType
    }
  }
`;

export const MENU_MODULE_LIST = gql`
  query {
    moduleList {
      name
      moduleId
    }
  }
`;

export const CLIENT_MODULES_BY_MENU = gql`
  query {
    currentClient {
      modules {
        moduleId
        moduleName
        moduleDescription
      }
      clientId
      clientName
    }
  }
`;

export const ALL_SURVEYS_BY_USER_ROLE = gql`
  query (
    $searchBy: String
    $first: Int
    $last: Int
    $after: String
    $before: String
  ) {
    allSurveysByUserRole(
      first: $first
      after: $after
      last: $last
      before: $before
      order: { idSurvey: DESC }
      searchBy: $searchBy
    ) {
      totalCount
      nodes {
        idSurvey
        surveyName
        surveyDescription
        idSurveyState
        activateSurveyDate
        createUser
        countryId
        integrationTpclient
      }
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;

export const ALL_FORMS_BY_USER_ROLE = gql`
  query (
    $searchBy: String
    $first: Int
    $last: Int
    $after: String
    $before: String
  ) {
    allFormsByUserRole(
      first: $first
      after: $after
      last: $last
      before: $before
      order: { idSurvey: DESC }
      searchBy: $searchBy
    ) {
      totalCount
      nodes {
        idSurvey
        surveyName
        surveyDescription
        idSurveyState
        activateSurveyDate
        createUser
        countryId
        integrationTpclient
      }
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;

export const ALL_ASSIGNED_SURVEYS_FROM_TO = gql`
  query ($fromDate: DateTime!, $toDate: DateTime!) {
    filterMyAssignedSurveys(
      filterByDate: { fromDate: $fromDate, toDate: $toDate }
    ) {
      idSurvey
      surveyName
      surveyDescription
      activateSurveyDate
      createUser
      idSurveyState
      startDate
      endDate
      isAnonymous
      goToSurveyInfo {
        goToSurvey
        schedule {
          idSurveyScheduling
          startDate
          endDate
        }
      }
    }
  }
`;

export const ALL_ASSIGNED_SURVEYS = gql`
  query (
    $searchBy: String
    $first: Int
    $last: Int
    $after: String
    $before: String
  ) {
    allAssignedSurveys(
      searchBy: $searchBy
      first: $first
      last: $last
      after: $after
      before: $before
      order: { idSurvey: DESC }
    ) {
      nodes {
        idSurvey
        surveyName
        surveyDescription
        activateSurveyDate
        createUser
        idSurveyState
        startDate
        endDate
        isAnonymous
        goToSurveyInfo {
          goToSurvey
          schedule {
            idSurveyScheduling
            startDate
            endDate
          }
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      totalCount
    }
  }
`;

export const ALL_ASSIGNED_FORMS = gql`
  query (
    $searchBy: String
    $first: Int
    $last: Int
    $after: String
    $before: String
  ) {
    allAssignedForms(
      searchBy: $searchBy
      first: $first
      last: $last
      after: $after
      before: $before
      order: { idSurvey: DESC }
    ) {
      nodes {
        idSurvey
        surveyName
        surveyDescription
        activateSurveyDate
        createUser
        idSurveyState
        goToSurveyInfo {
          goToSurvey
          schedule {
            idSurveyScheduling
            startDate
            endDate
          }
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      totalCount
    }
  }
`;

export const ALL_HISTORY_SURVEYS = gql`
  query (
    $searchBy: String
    $first: Int
    $last: Int
    $after: String
    $before: String
  ) {
    mySurveysHistory(
      searchBy: $searchBy
      first: $first
      last: $last
      after: $after
      before: $before
      order: { idSurvey: DESC }
    ) {
      nodes {
        idSurvey
        surveyName
        surveyDescription
        activateSurveyDate
        createUser
        idSurveyState
        hasAnswerPreview
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      totalCount
    }
  }
`;

export const ALL_HISTORY_FORMS = gql`
  query (
    $searchBy: String
    $first: Int
    $last: Int
    $after: String
    $before: String
  ) {
    myFormsHistory(
      searchBy: $searchBy
      first: $first
      last: $last
      after: $after
      before: $before
      order: { idSurvey: DESC }
    ) {
      nodes {
        idSurvey
        surveyName
        surveyDescription
        activateSurveyDate
        createUser
        idSurveyState
        hasAnswerPreview
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      totalCount
    }
  }
`;

export const ALL_USERS_ADMINISTRATION = gql`
  query (
    $searchBy: String!
    $first: Int
    $last: Int
    $after: String
    $before: String
  ) {
    userAdminList(
      searchBy: $searchBy
      first: $first
      last: $last
      after: $after
      before: $before
    ) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      totalCount
      nodes {
        isCoMoUser
        userTpId
        userEmail
        supervisorInfo {
          userFullName
        }
        userId
        location {
          cityName
          clientName
          countryName
        }
        userFirstName
        userLastName
        userCcms
        lobs {
          lobName
        }
        role {
          roleId
          roleName
        }
        enabled
      }
    }
  }
`;

export const GET_USER_INFO = gql`
  query ($usersIds: [Int!]!) {
    userAdminlistByIds(userIds: $usersIds) {
      supervisorId
      userId
      userFirstName
      userLastName
      userTpId
      userEmail
      userCcms
      isCoMoUser
      userTpId
      location {
        countryId
        countryName
        cityId
        cityName
      }
      role {
        roleId
        roleName
      }
      enabled
      lobs {
        lobId
        lobName
      }
    }
  }
`;

export const GET_UPDATE_TPID_CONFIRMATION = gql`
  query {
    currentUser {
      tpIdValidated
    }
  }
`;

export const ANSWERS_PREVIEW_BY_SURVEY_ID = gql`
  query ($surveyId: Int!) {
    answersPreviewBySurveyId(surveyId: $surveyId) {
      idSurveyNavigation {
        idSurvey
        surveyName
        surveyDescription
      }
      tpsurveyAnswerClients {
        code
        idQuestion
        titleAnswer
        answerClient
        idQuestionNavigation {
          nameQuestion
        }
      }
    }
  }
`;

export const GET_POLICIES = gql`
  query ($search: String, $countryId: Int, $first: Int) {
    policies(
      first: $first
      countryId: $countryId
      searchBy: $search
      order: { idMainPolicy: DESC }
    ) {
      totalCount
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      nodes {
        idMainPolicy
        policyName
        recordStatus
        countryId
        countryInfo {
          countryId
          countryName
        }
        createUserInfo {
          fullName
        }
        createUser
        createDate
        policySubPolicies {
          mainPolicy {
            countryId
          }
          idSubPolicy
          subPolicyName
          recordStatus
          createUser
          createDate
          createUserInfo {
            fullName
          }
          mainPolicyId
          lobs {
            lobid
            name
          }
        }
      }
    }
  }
`;

export const GET_POLICIES_AFTER = gql`
  query ($search: String, $countryId: Int, $first: Int, $after: String) {
    policies(
      first: $first
      countryId: $countryId
      searchBy: $search
      after: $after
      order: { idMainPolicy: DESC }
    ) {
      totalCount
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      nodes {
        idMainPolicy
        policyName
        recordStatus
        countryId
        countryInfo {
          countryId
          countryName
        }
        createUserInfo {
          fullName
        }
        createUser
        createDate
        policySubPolicies {
          mainPolicy {
            countryId
          }
          idSubPolicy
          subPolicyName
          recordStatus
          createUser
          createDate
          createUserInfo {
            fullName
          }
          lobs {
            lobid
            name
          }
        }
      }
    }
  }
`;

export const GET_POLICIES_BEFORE = gql`
  query ($search: String, $countryId: Int, $last: Int, $before: String) {
    policies(
      last: $last
      before: $before
      countryId: $countryId
      searchBy: $search
      order: { idMainPolicy: DESC }
    ) {
      totalCount
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      nodes {
        idMainPolicy
        policyName
        recordStatus
        countryId
        countryInfo {
          countryId
          countryName
        }
        createUserInfo {
          fullName
        }
        createUser
        createDate
        policySubPolicies {
          mainPolicy {
            countryId
          }
          idSubPolicy
          subPolicyName
          recordStatus
          createUser
          createDate
          createUserInfo {
            fullName
          }
          lobs {
            lobid
            name
          }
        }
      }
    }
  }
`;

export const GET_LOBS = gql`
  query ($countryId: Int!) {
    lobsListByCountry(countryId: $countryId, where: { enabled: { eq: true } }) {
      lobId
      lobName
      lobDescription
      enabled
      createDate
      createName
      country {
        countryId
        countryName
      }
    }
  }
`;

export const ADMIN_LOCATIONS_LIST = gql`
  query (
    $searchBy: String!
    $first: Int
    $after: String
    $last: Int
    $before: String
  ) {
    locationsAdminList(
      first: $first
      after: $after
      last: $last
      before: $before
      searchBy: $searchBy
      order: { createDate: DESC }
    ) {
      totalCount
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      nodes {
        countryId
        countryName
        cityId
        cityName
        createUser
        createDate
        enabled
      }
    }
  }
`;

export const ALL_COUNTRY_LIST = gql`
  query {
    allCountryList {
      countryId
      countryName
      cities {
        cityId
        cityName
      }
    }
  }
`;


export const ALL_CITIES_BY_COUNTRY_ID_LIST = gql`
  query($countryId: Int!) {
    allCitiesByCountryId(countryId:$countryId) {
      cityId
      cityName
    }
  }
`;

export const MOOD_METER_REQUESTS = gql`
  query {
    moodMeterRequests(order: { idMoodMeterRequest: DESC }) {
      idMoodMeterRequest
      name
      tpId
      location
      dateTime
      ack
    }
  }
`;

export const COACH_EVENTS = gql`
  query (
    $first: Int
    $after: String
    $last: Int
    $before: String
    $startDate: DateTime
    $finishDate: DateTime
    $countriesId: [Int!]
    $citiesId: [Int!]
    $counsellingThemeId: Int
    $searchBy: String
    $eventType: String
  ) {
    allCoachEventsList(
      first: $first
      after: $after
      last: $last
      before: $before
      startDate: $startDate
      finishDate: $finishDate
      countriesId: $countriesId
      citiesId: $citiesId
      counsellingThemeId: $counsellingThemeId
      searchBy: $searchBy
      eventType: $eventType
      order: { themeCheck: ASC, startDate: ASC }
    ) {
      totalCount
      nodes {
        idEvent
        eventName
        description
        idCategory
        idCategoryNavigation {
          idCategory
          categoryName
        }
        createDate
        startDate
        finishDate
        createUser
        eventState
        participantsLimit
        wellnessParticipants {
          attendStatus
          userId
          recordState
        }
        wellnessEventFeedbacks {
          rating
          idUser
          observations
        }
        eventType
        wellnessEventsCounsellingThemes {
          idCounsellingTheme
          idCounsellingThemeNavigation {
            themeName
            idCounsellingTheme
          }
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`;

export const ALL_ACTIVE_COUNSELLING_THEME = gql`
  query {
    allCounsellingThemes(
      first: 50
      order: { themeName: ASC }
      where: { recordState: { eq: "Active" } }
    ) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      totalCount
      nodes {
        idCounsellingTheme
        themeName
        recordState
        jsonConfiguration
      }
    }
  }
`;

export const ALL_COUNSELLING_THEME = gql`
  query (
    $searchBy: String
    $first: Int
    $last: Int
    $after: String
    $before: String
  ) {
    allCounsellingThemes(
      searchBy: $searchBy
      first: $first
      last: $last
      after: $after
      before: $before
      order: { createDate: DESC }
    ) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      totalCount
      nodes {
        idCounsellingTheme
        themeName
        recordState
        createUser
        createDate
      }
    }
  }
`;

export const UPCOMING_EVENTS_LIST = gql`
  query ($startSearch: DateTime!, $endSearch: DateTime!) {
    myUpcomingEvents(startSearch: $startSearch, endSearch: $endSearch) {
      idEvent
      eventName
      startDate
    }
  }
`;

// ADD NEW ACCOUNTS
export const MY_CLIENT_SWITCH_LIST = gql`
  query {
    myClientSwitchList {
      clientId
      clientName
      logoName
    }
  }
`;
export const COUNTRIES_BY_CLIENT_ID = gql`
  query ($clientId: Int!) {
    countryLocationList(clientId: $clientId) {
      id: countryId
      name: countryName
      cities {
        cityId
        cityName
      }
    }
  }
`;

export const LOBS_LIST_BY_COUNTRY = gql`
  query ($countryId: Int!, $clientId: Int!) {
    lobsListByCountry(
      countryId: $countryId
      clientId: $clientId
      where: { enabled: { eq: true } }
    ) {
      lobId
      lobName
      lobDescription
      enabled
      country {
        countryId
        countryName
      }
      client {
        clientId
        clientName
      }
    }
  }
`;

export const USER_DETAIL_BY_ID = gql`
  query ($userId: Int!) {
    userDetailById(userId: $userId) {
      userId
      userFullName
      userFirstName
      userLastName
      userCcms
      isCoMoUser
      userEmail
      userTpId
      supervisorId
      enabled
      supervisorInfo {
        userFullName
      }
      role {
        roleId
        roleName
      }
      lobs {
        lobId
        lobName
      }
      location {
        cityId
        cityName
        countryId
        countryName
        clientId
        clientName
      }
      additionalTenants {
        role {
          roleId
          roleName
        }
        lobs {
          lobId
          lobName
        }
        location {
          cityId
          cityName
          countryId
          countryName
          clientId
          clientName
        }
        supervisorId
        supervisorInfo {
          userId
          userFullName
        }
        isCoMoUser
      }
    }
  }
`;

export const MY_PROFILE_PICTURE = gql`
  query {
    myProfilePicture {
      avatarType
      jsonConfig
      imageName
    }
  }
`;
